import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLockOpen20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.861 3.587c.238-.36.639-.58 1.092-.706.448-.125.862-.133.998-.13h.031l.112.001A2.905 2.905 0 0 1 13 5.658V7.5H5.5A2.5 2.5 0 0 0 3 10v6.5A2.5 2.5 0 0 0 5.5 19h9a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5V5.658a4.406 4.406 0 0 0-4.406-4.406h-.064l-.057-.002a5.2 5.2 0 0 0-1.422.186c-.635.176-1.425.544-1.94 1.323-.244.367-.38.596-.458.744q-.06.11-.091.193a1 1 0 0 0-.052.184l-.003.018-.001.01v.004l-.001.003c0 .001 0 .002.745.085l-.745-.083a.75.75 0 0 0 1.456.321l.017-.032c.046-.087.153-.271.383-.619m3.389 9.663a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen20Filled);
